import { Link } from 'react-router-dom'
import { MainNavItemProps } from '../menuTypes'

export function MainNavItem({ item, onEnter, onLeave }: MainNavItemProps) {
  const isExternal = /^https?:\/\//i.test(item.url)
  const linkClassName =
    'cursor-pointer text-[#001A3D] hover:text-[#6596D7] text-base sm:text-sm lg:text-base xl:text-lg text-slate-500 font-medium xl:font-bold leading-normal tracking-wide whitespace-nowrap'

  return (
    <li
      className='relative leading-25'
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      {isExternal ? (
        <a
          href={item.url}
          target='_blank'
          rel='noopener noreferrer'
          className={linkClassName}
        >
          {item.name}
        </a>
      ) : (
        <Link to={item.url} className={linkClassName}>
          {item.name}
        </Link>
      )}
    </li>
  )
}
